<template>
  <div id="mobile-app" class="min-h-screen bg-gray-50 flex flex-col">
    <!-- 顶部导航栏 -->
     <!-- 不显示顶部导航栏 -->
    <!-- <MobileHeader 
      :title="currentPageTitle" 
      :show-back="showBackButton"
      :unread-count="unreadMessageCount"
      @back="handleBack"
      @message="handleMessage" 
    /> -->
    
    <!-- 主内容区域 -->
    <main 
      ref="mainEl" 
      :class="[
        'flex-1 overflow-auto',
        showTabBar ? 'pb-16' : ''
      ]"
    >
      <router-view />
    </main>
    
    <!-- 底部导航栏 -->
    <MobileTabBar 
      v-if="showTabBar"
      :active-tab="activeTab"
      @tab-change="handleTabChange"
    />
    
    <!-- 全局加载提示 -->
    <div v-if="isLoading" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg p-4 flex items-center space-x-3">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
        <span class="text-gray-700">加载中...</span>
      </div>
    </div>
    
    <!-- Toast 消息 -->
    <MobileToast 
      v-if="toast.show"
      :message="toast.message"
      :type="toast.type"
      @close="hideToast"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
// import MobileHeader from './components/MobileHeader.vue'
import MobileTabBar from './components/MobileTabBar.vue'
import MobileToast from './components/MobileToast.vue'

const route = useRoute()
const router = useRouter()

const mainEl = ref(null)
const isLoading = ref(false)
// const unreadMessageCount = ref(3) // 模拟未读消息数量
const toast = ref({
  show: false,
  message: '',
  type: 'info'
})

// 页面标题映射（作为meta.title的回退）
// const pageTitles = {
//   '/mobile': '首页',
//   '/mobile/home': '首页',
//   '/mobile/purchase': '进货管理',
//   '/mobile/sales': '销售管理', 
//   '/mobile/inventory': '库存管理',
//   '/mobile/finance': '财务管理'
// }

// 需要显示底部导航的页面
const tabPages = ['/mobile', '/mobile/home', '/mobile/purchase', '/mobile/sales', '/mobile/inventory', '/mobile/finance']

// const currentPageTitle = computed(() => {
//   return route.meta?.title || pageTitles[route.path] || '内务云通ERP'
// })

const showTabBar = computed(() => {
  return tabPages.some(tab => route.path === tab || route.path.startsWith(tab + '/'))
})

// const showBackButton = computed(() => {
//   return !tabPages.includes(route.path)
// })

const activeTab = computed(() => {
  const path = route.path
  if (path.includes('/purchase')) return 'purchase'
  if (path.includes('/sales')) return 'sales'
  if (path.includes('/inventory')) return 'inventory'
  if (path.includes('/finance')) return 'finance'
  return 'home'
})

// 路由切换后重置主内容区与窗口滚动条
watch(
  () => route.fullPath,
  async () => {
    await nextTick()
    if (mainEl.value) {
      try {
        mainEl.value.scrollTop = 0
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('[MobileApp] reset main scrollTop failed:', e)
        }
      }
    }
    try {
      window.scrollTo({ top: 0, behavior: 'auto' })
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[MobileApp] window scrollTo failed:', e)
      }
    }
  }
)

// const handleBack = () => {
//   if (window.history.length > 1) {
//     router.go(-1)
//   } else {
//     router.push('/mobile')
//   }
// }

const handleTabChange = (tab) => {
  const routes = {
    home: '/mobile',
    purchase: '/mobile/purchase',
    sales: '/mobile/sales',
    inventory: '/mobile/inventory',
    finance: '/mobile/finance'
  }
  router.push(routes[tab])
}

// const handleMessage = () => {
//   router.push('/mobile/messages')
// }

const showToast = (message, type = 'info') => {
  toast.value = {
    show: true,
    message,
    type
  }
  setTimeout(() => {
    hideToast()
  }, 3000)
}

const hideToast = () => {
  toast.value.show = false
}

// 全局加载状态管理
const setLoading = (loading) => {
  isLoading.value = loading
}

// 提供给子组件使用
window.mobileApp = {
  showToast,
  setLoading
}
</script>

<style scoped>
#mobile-app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  /* 确保占满整个视口高度 */
  height: 100vh;
  height: 100dvh; /* 动态视口高度，支持移动端地址栏变化 */
}

/* 主内容区域样式优化 */
main {
  /* 确保内容可以正常滚动 */
  -webkit-overflow-scrolling: touch;
  /* 防止内容被底部导航遮挡的额外保险 */
  position: relative;
}

/* 当显示底部导航时，确保内容不被遮挡 */
main.pb-16 {
  /* 使用 padding-bottom 而不是 margin-bottom，避免滚动问题 */
  padding-bottom: 4rem; /* 64px，与底部导航高度一致 */
  /* 在有安全区域的设备上增加额外间距 */
  padding-bottom: calc(4rem + env(safe-area-inset-bottom));
}

/* 确保在移动设备上的适配 */
@media (max-width: 768px) {
  #mobile-app {
    font-size: 14px;
  }
  
  /* 移动端优化：确保内容区域正确处理 */
  main {
    min-height: 0; /* 允许 flex 子元素收缩 */
  }
}

/* 处理 iOS 设备的安全区域 */
@supports (padding: max(0px)) {
  main.pb-16 {
    padding-bottom: max(4rem, calc(4rem + env(safe-area-inset-bottom)));
  }
}
</style>